"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStorage = void 0;
var constants_1 = require("../constants");
var cookie_storage_1 = require("./cookie.storage");
var local_storage_1 = require("./local.storage");
var memory_storage_1 = require("./memory.storage");
var session_storage_1 = require("./session.storage");
var createStorage = function (config) {
    if (!config.storage.type) {
        throw new Error('config.storage.type is not present in configuration');
    }
    var storageEnum = constants_1.parseStorageEnum(config.storage.type);
    switch (storageEnum) {
        case constants_1.StorageEnum.COOKIE:
            return new cookie_storage_1.CookieStorage(config.storage.cookie);
        case constants_1.StorageEnum.MEMORY:
            return new memory_storage_1.MemoryStorage(config.storage.memory);
        case constants_1.StorageEnum.WINDOW:
            return new local_storage_1.LocalStorage(config.storage.window);
        case constants_1.StorageEnum.SESSION:
            return new session_storage_1.SessionStorage(config.storage.window);
        default:
            throw new Error('Invalid or unsuported storage type ' + config.storage.type);
    }
};
exports.createStorage = createStorage;
//# sourceMappingURL=index.js.map